<template>
    <div v-if="survey">
        <h1 class="tw-m-0 tw-text-xl md:tw-text-3xl">{{ survey.name }}</h1>

        <div
            data-test-id="survey-description"
            class="tw-text-gray-500 tw-my-8 tw-mb-2 tw-p-8 tw-bg-white tw-rounded-md tw-shadow-sm"
        >
            <div v-if="survey.description" v-html="survey.description" />

            <template v-else>
                {{ $t("surveys.participate.hiThereIntro") }}<br />
                <i18n path="surveys.participate.bodyIntro" for="value">
                    <b>{{ companyName }}</b>
                </i18n>
            </template>

            <div
                v-if="survey.settings.fullExportEnabled && !survey.settings.notAnonymous"
                class="tw-mt-4 tw-border-t tw-border-0 tw-border-solid tw-border-gray-200 tw-pt-4"
            >
                {{ $t("surveys.participate.fullExportEnabledHelp") }}
            </div>
        </div>

        <div class="tw-text-gray-400 tw-text-xs tw-mb-8 tw-text-right">
            <i class="fal fa-exclamation-triangle tw-mr-1" />
            {{ $t("surveys.participate.uniqueLinkWarning") }}
        </div>

        <div class="tw-flex tw-justify-end tw-items-center">
            <l-base-button
                :button-types="['primary', 'raised', 'inline']"
                :class="{ 'tw-animate-bounce': highlightCta }"
                data-test-id="start-survey-action"
                @click.native="onNavigateToNextStep()"
            >
                <span>{{ $t("surveys.participate.btnLetsGo") }}</span>
                <span><i class="fal fa-chevron-right tw-ml-2"/></span>
            </l-base-button>

            <l-keyboard-hint-text class="tw-ml-2" :keys="['enter']">
                <span slot="prefix">{{ $t("surveys.participate.keyPress") }} </span>
            </l-keyboard-hint-text>
        </div>
    </div>
</template>

<script>
import LBaseButton from "@/components/LBaseButton";
import LKeyboardHintText from "@/components/LKeyboardHintText";

export default {
    components: {
        LBaseButton,
        LKeyboardHintText,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        highlightCta: {
            type: Boolean,
            default: false,
        },
        companyName: {
            type: String,
            default: "",
        },
    },
    methods: {
        onNavigateToNextStep(direction = 1) {
            this.$store.dispatch("surveys/answerSession/navigateToNextStep", {
                payload: { direction },
            });
        },
    },
};
</script>
